/**
 * Кнопка-вопрос с подсказкой
 * text
 * maxWidth - tooltip max width (default: 250)
 * contentStyle - tooltip content styles object
 *
 * slots:
 *  - text
 */


import { ViewModel as model } from './model';
import template from './template.html';
import './style.less';



import { registerComponent } from 'Utils/engine/register-component';
registerComponent('fc-question', { model, template});
